var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-editor',{attrs:{"editor-toolbar":_vm.toolbar},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }